module.exports = __webpack_public_path__ + "img/es.98a9366e.png";